import { AnimatePresence } from 'framer-motion';
import { Toast } from '@ui';
import { useToast } from '@shared/hooks/useToast';
import { useIsMobile } from '@shared/hooks/useIsMobile';

/**
 * The stack itself carries no styling opinion of its own — that lives in Toast, from the design
 * system. Top-right, under the top bar rather than over it — the corner is already the teacher's
 * own actions (Ajouter, notifications, avatar), so a toast overlapping them would read as one more
 * button rather than a message about what just happened.
 *
 * Mobile has no such corner to avoid, and a message pinned top-right sits over the thumb's least
 * reachable spot on a one-handed phone — bottom, centred, at the same `bottom-5` offset as the
 * FAB it sits alongside rather than floating above it.
 */
export const ToastContainer = () => {
  const { toasts, removeToast } = useToast();
  const isMobile = useIsMobile();

  return (
    <div
      className={
        isMobile
          ? "fixed inset-x-0 bottom-5 z-[80] flex flex-col items-center gap-2.5 px-3.5 pointer-events-none"
          : "fixed top-topbar right-5 mt-2.5 z-[80] flex flex-col items-end gap-2.5 pointer-events-none"
      }
    >
      <AnimatePresence>
        {toasts.map((toast) => (
          <div key={toast.id} className="pointer-events-auto">
            <Toast
              message={toast.message}
              variant={toast.type}
              onDismiss={() => removeToast(toast.id)}
            />
          </div>
        ))}
      </AnimatePresence>
    </div>
  );
};
